import axios, { AxiosError } from 'axios';
import { auth } from '../firebase';


interface ApiError {
  message?: string;
}

export const backendAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});


export const create_template = async (title: string, type: string, nodes: any, edges: any, businessId: number)=> {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.post(
      `templates/create/`,
      { title, type, nodes, edges, businessId },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        }
      }
    );
    return response;
  } catch (error) {
    console.error('Error creating template:', error);
    throw error; // Rethrow the error for handling in your component or context
  }
};

export const get_user_templates = async () => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.get(
      'templates/user_templates',
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        }
      }
    );
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Get user templates failed');
  }
};

export const get_user_template = async (templateId: number)=> {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.get(
      'templates/user_template', 
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
        params: { templateId }
      }
    );
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Get user template failed');
  }
};

export const edit_template = async (templateId: number)=> {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.put(
      'templates/user_template', 
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
        params: { templateId }
      }
    );
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Edit user template failed');
  }
};

export const delete_template = async (templateId: number)=> {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.delete(
      `templates/delete/${templateId}`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        }
      }
    );
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Delete user template failed');
  }
};

export const get_businesstype_templates = async (businessId: number) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.get(
      `/templates/businesstype/${businessId}`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        }
      }
    );
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Get business templates failed');
  }
};

export const save_template = async (templateId: number, nodes: any, edges: any)=> {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.put(
      `templates/save/`,
      { templateId, nodes, edges},
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        }
      }
      );
    return response;
  } catch (error) {
    console.error('Error saving template:', error);
    throw error; // Rethrow the error for handling in your component or context
  }
};

export const set_template = async (templateId: number, userBusinessId: number)=> {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.post(
      `templates/settemplate/`,
      { templateId, userBusinessId },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        }
      }
    );
    return response;
  } catch (error) {
    console.error('Error creating template:', error);
    throw error; // Rethrow the error for handling in your component or context
  }
};

export const get_userbusiness_template = async (userBusinessId: number) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.get(
      `/templates/userbusinesstemplate/${userBusinessId}`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        }
      }
    );
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Get user templates failed');
  }
};

export const get_alluserbusiness_templates = async (userBusinessId: number) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.get(
      `/templates/alluserbusinesstemplates/${userBusinessId}`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        }
      }     
    );
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Get user templates failed');
  }
};

export const get_templates = async () => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.get(
      `templates/all`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        }
      }
    );
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Get templates failed');
  }
};
